<template>
  <div class="work-page">
    <h1 class="title-page">
      <span class="hov">M</span>
      <span class="hov">y</span>
      <span class="space"></span>
      <span class="hov">p</span>
      <span class="hov">r</span>
      <span class="hov">o</span>
      <span class="hov">j</span>
      <span class="hov">e</span>
      <span class="hov">c</span>
      <span class="hov">t</span>
      <span class="hov">s</span>
    </h1>

    <div class="work-list">
      <div class="work" v-for="work in myProjects" :key="work.key">
        <div class="information">
          <h2 class="work-number">0{{ work.key }}.</h2>
          <h1 class="work-title">
            {{ work.title }}
          </h1>
          <img
            :src="require(`@/assets/${work.img}`)"
            alt=""
            class="mobile-img"
          />
          <p class="description">
            {{ work.description }}
          </p>
          <div class="tools">
            <p>
              Code Tools :
              <span>{{ work.codeTools.join(", ") }}</span>
            </p>
            <p class="design">
              Design : <span>{{ work.design }}</span>
            </p>
          </div>
          <div class="links">
            <a
              target="_blank"
              :href="work.link"
              :class="work.link === '' ? 'disabled' : ''"
              >Visit</a
            >
            <a
              target="_blank"
              :href="work.source"
              :class="work.source === '' ? 'disabled' : ''"
              >Source Code</a
            >
          </div>
        </div>
        <div class="img">
          <img :src="require(`@/assets/${work.img}`)" alt="" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
 export default {
   data() {
     return {
       isExpand: false,
       icon: "fas fa-expand",
       isDetail: false,
       myProjects: [
         {
           title: "Animeriq V1 (front-end)",
           description:
             "Anime website for people who love anime. I built this website with ReactJS and Axios for search webscraper",
           source: "https://gitlab.com/riq666/frontend-animeriq",
           link: "https://anime.mikailthoriq.eu.org",
           codeTools: ["ReactJS", "NodeJs", "ExpressJS", "Axios"],
           design: "Design by Me",
           img: "animeriq-0.1.3.png",
           key: 1,
         },
         {
           title: "Lab",
           description:
             "Riq's old web Lab is a collection of different project like php or else.",
           source: "",
           link: "https://lab.riq.my.id",
           img: "labhome1.png",
           codeTools: ["HTML", "CSS", "Javascript", "PHP"],
           design: "Design by Me",
           key: 2,
         },
         {
           title: "OSINT | Riq mirror",
           description: "framework focused on gathering information from free tools or resources.",
           source: "https://github.com/thq642/osint",
           link: "https://osint.mikailthoriq.eu.org",
           img: "osinthompage1.png",
           codeTools: ["HTML", "CSS", "Javascript"],
           design: "Design by https://github.com/lockfale",
           key: 3,
         },
        {
          title: "Weatheriq",
          description: "A weather app that shows the weather in your location. It uses OpenWeatherMap API.",
          source: "https://github.com/thq642/weather-webapp",
          link: "https://weather.mikailthoriq.eu.org",
          img: "weatherbyriq.png",
          design: "Design by Me",
          codeTools: ["HTML", "CSS", "Javascript", "Webpack", "OpenWeatherMap API"],
          key: 4,
        },
        {
          title: "Others Website Revision",
          description: "A collection of my old personal website revision.",
          source: "",
          link: "https://legacy.mikailthoriq.my.id",
          img: "others.png",
          codeTools: ["Too Many"],
          design: "Design By Me",
          key: 5,
        }
       ],
     };
   },
   mounted() {},
   methods: {},
 };
</script>

<style scoped src="../../public/styles/work.css"></style>
